import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type ItemLocationHistoryEntryDetailFragment = { __typename?: 'ItemLocationHistoryEntry', id: string, item_id: string, current_location_id: string, next_location_id?: string | null, arrival_date: string, departure_date?: string | null, current_location_name?: string | null, next_location_name?: string | null, booked_by_id?: string | null, booked_by?: string | null, order_fulfillment_id?: string | null, status?: Types.ContainerStationStatus | null, item_type?: { __typename?: 'ItemType', id: number, name: string, category: Types.ItemTypeCategory, archived: boolean, image_url?: string | null, color_hex_code?: string | null } | null, event?: { __typename?: 'EventReduced', id?: string | null, name?: string | null } | null, pictures: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url: string, url_full_size: string, created_at: string, created_by_id: string, created_by_name: string, comment?: string | null, taken_at?: string | null, street?: string | null, city?: string | null, country_code?: string | null, postal_code?: string | null, latitude?: number | null, longitude?: number | null }>, container_type_amounts: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, amount: number, amount_sealed: number }> };

export const ItemLocationHistoryEntryDetailFragmentDoc = gql`
    fragment ItemLocationHistoryEntryDetail on ItemLocationHistoryEntry {
  id
  item_id
  current_location_id
  next_location_id
  arrival_date
  departure_date
  current_location_name
  next_location_name
  booked_by_id
  booked_by
  order_fulfillment_id
  item_type {
    id
    name
    category
    archived
    image_url
    color_hex_code
  }
  event {
    id
    name
  }
  pictures {
    id
    url
    url_full_size
    created_at
    created_by_id
    created_by_name
    comment
    taken_at
    street
    city
    country_code
    postal_code
    latitude
    longitude
  }
  status
  container_type_amounts {
    container_type_id
    container_type_name
    container_type_image
    amount
    amount_sealed
  }
}
    `;